<template>
    <v-card
      :style="'border-left: 8px solid ' + ((station==null) ? 'black' : station.color)"
      :loading="station == null"
    >
      <v-card-title>
        <h2>
          {{ station==null ? 'Gleich da...' : station.display_name }}
        </h2>
        <v-spacer></v-spacer>
        <v-tooltip
          v-if="station.alarmgroup_id in $store.state.kentix.alarmgroups_status"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                v-if="$store.state.kentix.alarmgroups_status[station.alarmgroup_id][0]"
                class="ml-1 success--text"
              >
                mdi-door-closed-lock
              </v-icon>
              <v-icon
                v-else
                class="ml-1 error--text"
              >
                mdi-door-open
              </v-icon>
            </div>
          </template>
          <span>Zuletzt geändert: {{ last_action_formatted }}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text
        v-if="station != null"
      >
        <Station_Engine
          v-for="(engine, engine_key) in station.engines"
          :key="engine_key"
          :issi="engine.issi"
        ></Station_Engine>
      </v-card-text>
      <v-card-text
        v-else
      >
        <v-skeleton-loader
          type="table-tfoot, table-tfoot"
        ></v-skeleton-loader>
      </v-card-text>
    </v-card>
</template>

<script>

import Station_Engine from "./Station_Engine";
export default {
  name: "Station",
  components: { Station_Engine },
  props: ["station"],
  computed: {
    last_action_formatted(){
      let unix_timestamp = this.$store.state.kentix.alarmgroups_status[this.station.alarmgroup_id][1];
      let date = new Date(unix_timestamp * 1000)
      return date.toLocaleDateString() + " - " + date.toLocaleTimeString() + " Uhr";
    }
  }
};
</script>

<style scoped>

</style>
